// 已存搜尋（vms-web SRCH-03；platform cmd/app-api/vmssavedsearch.go）：個人 / org 共用。只存查詢字串與畫面狀態，
// 套用時照一般搜尋重新授權。每個 plane 各一份，前端合併。
import { kinioFetch, planeBase } from '@kinio/web-sdk';

export interface SavedSearchFilters {
  sort?: 'time' | 'relevance';
  /** 勾選的分級（EventsPage 的 chip）；沒有 = 不動 */
  levels?: string[];
}

export interface SavedSearch {
  search_id: string;
  scope: 'user' | 'org';
  owner_org_id?: string;
  name: string;
  query: string;
  filters: SavedSearchFilters;
  can_write: boolean;
  updated_at: string;
  /** 前端補：這份來自哪個 plane。 */
  api: string;
}

type Wire = Omit<SavedSearch, 'api'>;

export const savedSearchApi = {
  list: (api: string) =>
    kinioFetch<{ data: Wire[]; org_admin_of: string[] }>(`${planeBase(api)}/v1/vms/saved-searches`).then((r) => ({
      data: (r?.data ?? []).map((s) => ({ ...s, filters: s.filters ?? {}, api })),
      orgAdminOf: r?.org_admin_of ?? [],
    })),
  create: (api: string, body: { scope: 'user' | 'org'; org_id?: string; name: string; query: string; filters: SavedSearchFilters }) =>
    kinioFetch<Wire>(`${planeBase(api)}/v1/vms/saved-searches`, { method: 'POST', body }),
  remove: (api: string, id: string) => kinioFetch(`${planeBase(api)}/v1/vms/saved-searches/${encodeURIComponent(id)}`, { method: 'DELETE' }),
};

/** 合併多個 plane 的清單：個人的在前、再依名稱。 */
export function mergeSaved(lists: (SavedSearch[] | undefined)[]): SavedSearch[] {
  return lists.flatMap((l) => l ?? []).sort((a, b) => (a.scope === b.scope ? a.name.localeCompare(b.name) : a.scope === 'user' ? -1 : 1));
}
